<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.power-register-cycles.cycles' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.value"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="number" formControlName="value" placeholder="0" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.power-register-cycles.last-cycles' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.value"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="number" formControlName="lastValue" placeholder="0" class="ir-form-set" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
